import { PharmacyPagination } from './shared/PharmacyUI';
import { PharmacyMetric } from './shared/PharmacyUI';
import { PharmacySelect, PharmacyDownloadDialog, PharmacyTabs } from './shared/PharmacyUI';
import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, CircularProgress, Alert, Autocomplete, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import FichaProductoModal from './FichaProductoModal';
import ActualizacionesModal from './ActualizacionesModal';
import { HeaderIOS, IOS } from './shared/MenuLayout';
import './shared/Productos.css';

const TablePagination = ({count,page,onPageChange,rowsPerPage,onRowsPerPageChange}) => <PharmacyPagination total={count} pagina={page+1} setPagina={p=>onPageChange(null,p-1)} rpp={rowsPerPage} setRpp={n=>onRowsPerPageChange({target:{value:String(n)}})}/>;

// ── Pill estado ───────────────────────────────────────────────────────────────
const EstadoPill = ({ estado }) => {
  const cfg = {
    'VENCIDO':    { bg:'#FFF0EF', border:'#FFD4D1', text:'#C0392B', dot:'#D58089' },
    'POR VENCER': { bg:'#FFF8E6', border:'#FFE9A0', text:'#8B6914', dot:'#D4A365' },
    'VIGENTE':    { bg:'#EDFAF2', border:'#B7EFD0', text:'#1A6B3C', dot:'#65AA91' },
  }[estado] || { bg:IOS.bg, border:IOS.separator, text:IOS.label2, dot:IOS.label2 };
  return (
    <Box sx={{display:'inline-flex',alignItems:'center',gap:0.6,px:1,py:0.3,
      borderRadius:'20px',bgcolor:cfg.bg,border:`1px solid ${cfg.border}`}}>
      <Box sx={{width:5,height:5,borderRadius:'50%',bgcolor:cfg.dot}}/>
      <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:cfg.text}}>{estado}</Typography>
    </Box>
  );
};

// ── Botón acción ──────────────────────────────────────────────────────────────
const Btn = ({ onClick, color, title, children }) => (
  <Box className="pharmacy-action" component="button" onClick={onClick} title={title} aria-label={title}
    sx={{width:28,height:28,borderRadius:'50%',border:'none',bgcolor:`${color}15`,
      color,display:'inline-flex',alignItems:'center',justifyContent:'center',
      cursor:'pointer',mx:0.3,transition:'all 0.15s',
      '&:hover':{bgcolor:`${color}30`,transform:'scale(1.1)'}}}>
    {children}
  </Box>
);

// ── Select ────────────────────────────────────────────────────────────────────
const Sel = PharmacySelect;

// ── TH / TR / TD ──────────────────────────────────────────────────────────────
const TH = ({children,right,w}) => (
  <th scope="col" title={typeof children==='string'?children:undefined} style={{padding:'9px 12px',width:w,textAlign:right?'right':'left',
    fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.06em',
    textTransform:'uppercase',backgroundColor:IOS.surface,
    borderBottom:`1px solid ${IOS.separator}`,position:'sticky',top:0,
    whiteSpace:'normal',zIndex:1}}><span className="product-column-label">{children}</span></th>
);

const TR = ({children}) => {
  const [h,setH] = useState(false);
  return (
    <tr onMouseEnter={()=>setH(true)} onMouseLeave={()=>setH(false)}
      style={{backgroundColor:h?IOS.bg:IOS.surface,transition:'background 0.1s',
        borderBottom:`1px solid ${IOS.separator}`}}>
      {children}
    </tr>
  );
};

const TD = ({children,right,mono,bold,color,nowrap}) => (
  <td style={{padding:'8px 12px',textAlign:right?'right':'left',
    fontFamily:mono?'ui-monospace,monospace':'inherit',
    fontWeight:bold?700:400,color:color||IOS.label,
    whiteSpace:nowrap?'nowrap':'normal',fontSize:'0.78rem'}}>{children}</td>
);

const fmtFecha = (f) => {
  if (!f) return '—';
  const d = new Date(f);
  const dd = String(d.getDate()).padStart(2,'0');
  const mm = String(d.getMonth()+1).padStart(2,'0');
  return `${dd}/${mm}/${d.getFullYear()}`;
};

// ── Modal exportar IOS ────────────────────────────────────────────────────────
const ModalExportar = ({ open, onClose, tab, totalStock, totalVenc, onExportar, exportando, fichaIpress, error }) => {
  if (!open) return null;

  const opcionesStock = [
    { fmt:'pdf-stock',           label:'PDF Resumido',  sub:'Vista agrupada',    
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> },
    { fmt:'excel-stock',         label:'Excel Stock',   sub:'Hoja de cálculo',    
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="12" y1="10" x2="12" y2="20"/></svg> },
    { fmt:'pdf-stock-detallado', label:'PDF Detallado', sub:'Con lotes y precios', 
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/><line x1="8" y1="9" x2="10" y2="9"/></svg> },
    { fmt:'excel-stock-detallado',label:'Excel Detallado',sub:'Con lotes y precios',
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0891B2" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="12" y1="10" x2="12" y2="20"/><line x1="8" y1="17" x2="16" y2="17"/></svg> },
  ];

  const opcionesVenc = [
    { fmt:'pdf-vencimiento', label:'PDF Vencimiento', sub:'Reporte completo', 
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/></svg> },
    { fmt:'excel-vencimiento', label:'Excel Vencimiento', sub:'Hoja de cálculo', 
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="12" y1="10" x2="12" y2="20"/></svg> },
  ];

  const opcionesFicha = [
    { fmt:'excel-ficha', label:'Resumen', sub:'Total por fuente, 12 meses', color:'#059669', ext:'XLSX',
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="12" y1="10" x2="12" y2="20"/></svg> },
    ...(fichaIpress ? [] : [{ fmt:'excel-ficha-detallado', label:'Detallado', sub:'Con IPRESS desglosadas', color:'#0891B2', ext:'XLSX',
      icon:<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0891B2" strokeWidth="1.5" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/><line x1="8" y1="9" x2="10" y2="9"/></svg> }]),
  ];

  const opciones = tab === 0 ? opcionesStock.slice(0,2) : tab === 1 ? opcionesStock.slice(2,4) : tab === 2 ? opcionesVenc : opcionesFicha;
  const total = tab === 3 ? null : tab === 0 ? totalStock : tab === 1 ? totalStock : totalVenc;

  return <PharmacyDownloadDialog open={open} onClose={onClose} total={total} subtitle={tab===3?'Ficha de producto':undefined} busy={exportando} options={opciones.map(o=>({...o,onClick:()=>onExportar(o.fmt)}))}>{error&&<Alert severity="error" sx={{mb:2}}>{error}</Alert>}</PharmacyDownloadDialog>;
};

// ══════════════════════════════════════════════════════════════════════════════
const Productos = () => {
  const navigate  = useNavigate();
  const user      = authService.getCurrentUser();
  const ueId      = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento || 0;

  const [tab, setTab]             = useState(0);
  const [tabAnterior, setTabAnterior] = useState(0);
  const volverDeFicha = () => { setMFicha({open:false,codigo:null,nombre:null}); setTab(tabAnterior); };
  const [fichaIpress, setFichaIpress] = useState(null); // null = TODOS
  const [busqueda, setBusq]       = useState('');
  const [cols, setCols]           = useState([]);
  const [prods, setProds]         = useState([]);
  const [totalReg, setTotalReg]   = useState(0);
  const [page, setPage]           = useState(0);
  const [rpp, setRpp]             = useState(()=>window.matchMedia('(max-width:599px)').matches?10:25);

  const [vencP, setVencP]         = useState([]);
  const [ipress, setIpress]       = useState([]);
  const [fIpress, setFIpress]     = useState('');
  const [fMeses, setFMeses]       = useState(3);
  const [fEstado, setFEstado]     = useState('TODOS');
  const [totV, setTotV]           = useState({ vencidos:0, porVencer:0, vigentes:0, totalEvaluados:0 });
  const [totalRegV, setTotalRegV] = useState(0);
  const [pageV, setPageV]         = useState(0);
  const [rppV, setRppV]           = useState(()=>window.matchMedia('(max-width:599px)').matches?10:25);

  const [loading, setLoading]     = useState(true);
  const [errors,setErrors]=useState({});
  const [metaReady,setMetaReady]=useState(false);
  const requestRef=useRef(0);
  const detailRef=useRef(0);
  const setError=(key,text)=>setErrors(prev=>({...prev,[key]:text}));
  const [ultimaAct, setUltimaAct] = useState('');
  const [exportando, setExportando] = useState(false);
  const [modalExportar, setModalExportar] = useState(false);

  const [mFicha, setMFicha]       = useState({ open:false, codigo:null, nombre:null });
  const [mActs, setMActs]         = useState(false);

  // Tab detalle IPRESS
  const idEstabUsuario = String(user?.idEstablecimiento||user?.IdEstablecimiento||0);
  const [privProd, setPrivProd]   = useState('Solo lectura');
  const [ipressDet, setIpressDet] = useState([]);
  const [ipressSelDet, setIpressSelDet] = useState('');
  const [detData, setDetData]     = useState([]);
  const [loadDet, setLoadDet]     = useState(true);
  const [detCargadoEn, setDetCargadoEn] = useState(null);
  const [busqDet, setBusqDet]     = useState('');
  const [filtDetIpress, setFiltDetIpress] = useState('');
  const [filtDetExtra, setFiltDetExtra]   = useState('');
  const [filtDetEsencial, setFiltDetEsencial] = useState('');
  const [filtDetEstrategico, setFiltDetEstrategico] = useState('');
  const [filtDetIndicador, setFiltDetIndicador] = useState('');
  const [nombreDetSel, setNombreDetSel] = useState('');
  const [pgDet, setPgDet]         = useState(1);
  const [rppDet, setRppDet]       = useState(()=>window.matchMedia('(max-width:599px)').matches?10:25);

  useEffect(()=>{
    api.get('/dashboard/permisos').then(r=>{
      if(r.data.success){
        const op=r.data.opciones.find(o=>(o.permiso||'').toLowerCase().includes('producto'));
        if(op) setPrivProd(op.privilegio||'Solo lectura');
      }
    }).catch(()=>{});
  },[]);

  const esTOTAL = privProd==='Total';

  useEffect(()=>{
    if(!privProd) return;
    api.get(`/farmacia/productos/listar-ipress?idEjecutora=${ueId}`).then(r=>{
      if(r.data.success&&r.data.data.length){
        const lista=r.data.data;
        const mi=lista.find(ip=>String(ip.idEstablecimiento)===idEstabUsuario)||lista[0];
        if(esTOTAL){ setIpressDet(lista); }
        else { setIpressDet([mi]); }
        setIpressSelDet(mi.idEstablecimiento);
      }
    }).catch(console.error);
  },[ueId,privProd]);

  const cargarDetalle = async()=>{
    const requestId=++detailRef.current;
    setLoadDet(true); setError(1,null);
    try {
      const r = await api.get(`/farmacia/productos/detalle-todos?ueId=${ueId}`);
      if(requestId!==detailRef.current)return;
      if(!r.data.success)throw new Error('Consulta fallida');
      setDetData(r.data.data); setDetCargadoEn(new Date()); setPgDet(1);
    } catch(e){if(requestId===detailRef.current)setError(1,'No pudimos cargar el detalle. Vuelve a intentarlo.');} finally{if(requestId===detailRef.current)setLoadDet(false);}
  };

  useEffect(()=>{
    if(tab===1&&ipressSelDet) cargarDetalle();
  },[tab,ipressSelDet]);

  const handleLogout = () => { authService.logout(); navigate('/login'); };

  useEffect(() => {
    Promise.all([
      api.get(`/farmacia/productos/columnas?ueId=${ueId}`),
      api.get(`/farmacia/productos/ultima-actualizacion?ueIdEstablecimiento=${ueId}`),
      api.get(`/farmacia/productos/listar-ipress?idEjecutora=${ueId}`),
    ]).then(([rC,rA,rI]) => {
      if(!rC.data.success)throw new Error('No se pudieron cargar las columnas');
      setCols(rC.data.data);
      setUltimaAct(rA.data.success ? rA.data.data : 'No disponible');
      if (rI.data.success && rI.data.data.length > 0) {
        setIpress(rI.data.data);
        setFIpress(rI.data.data[0].idEstablecimiento);
      }
    }).catch(()=>setError('meta','No pudimos cargar los establecimientos. Recarga la página para reintentar.')).finally(()=>setMetaReady(true));
  }, [ueId]);

  useEffect(() => {
    if(tab!==0||!metaReady)return;
    ++requestRef.current; setLoading(true);
    const t = setTimeout(() => buscar(busqueda, page, rpp), 350);
    return () => clearTimeout(t);
  }, [busqueda, page, rpp, tab, metaReady]);

  useEffect(() => { if (tab === 2 && fIpress !== '') cargarVenc(); }, [tab, fIpress, fMeses, fEstado, pageV, rppV]);

  const buscar = async (txt, pg=0, sz=50) => {
    const requestId=++requestRef.current; setError(0,null);
    if (txt.length > 0 && txt.length < 2) { setProds([]); setTotalReg(0); setLoading(false); return; }
    setLoading(true);
    try {
      const r = await api.get('/farmacia/productos/stock-agrupado',
        { params:{ ueId, busqueda:txt, page:pg+1, pageSize:sz } });
      if(requestId!==requestRef.current)return;
      if(!r.data.success)throw new Error('Consulta fallida');
      if (r.data.success) {
        const data = r.data.data.map(p => {
          let t = 0;
          cols.forEach(c => { t += parseFloat(p[c.columna])||0; });
          if (p.PERIFERIA) t += parseFloat(p.PERIFERIA)||0;
          return { ...p, TOTAL:t };
        });
        setProds(data); setTotalReg(r.data.total ?? data.length);
      }
    } catch(e) { if(requestId===requestRef.current)setError(0,'No pudimos consultar el stock. Inténtalo de nuevo.'); } finally { if(requestId===requestRef.current)setLoading(false); }
  };

  const cargarVenc = async () => {
    const requestId=++requestRef.current; setError(2,null);
    setLoading(true);
    try {
      const r = await api.get(`/farmacia/productos/vencimiento?idEstablecimiento=${ueId}&ipress=${encodeURIComponent(fIpress)}&meses=${fMeses}&page=${pageV+1}&pageSize=${rppV}&estado=${encodeURIComponent(fEstado)}`);
      if(requestId!==requestRef.current)return;
      if(!r.data.success)throw new Error('Consulta fallida');
      if (r.data.success) {
        setVencP(r.data.data||[]);
        setTotV(r.data.totales||{ vencidos:0, porVencer:0, vigentes:0, totalEvaluados:0 });
        setTotalRegV(r.data.total ?? r.data.data?.length ?? 0);
      }
    } catch(e) { if(requestId===requestRef.current)setError(2,'No pudimos consultar los vencimientos. Inténtalo de nuevo.'); } finally { if(requestId===requestRef.current)setLoading(false); }
  };

  const handleExportar = async (fmt) => {
    setExportando(true); setError('export',null);
    try {
      let url = '';
      let filename = '';

      if (fmt === 'pdf-stock') {
        url = `/farmacia/productos/pdf-stock?ueId=${ueId}&busqueda=${encodeURIComponent(busqueda)}`;
        filename = `Stock_Resumido_${Date.now()}.pdf`;
      } else if (fmt === 'pdf-stock-detallado') {
        const filtros = [
          busqDet?`Producto: ${nombreDetSel||busqDet}`:'',
          filtDetIpress?`IPRESS: ${filtDetIpress}`:'',
          filtDetExtra?`Lote/RS/FF: ${filtDetExtra}`:'',
          filtDetEsencial?`Esencial: ${filtDetEsencial}`:'',
          filtDetEstrategico?`Estratégico: ${filtDetEstrategico}`:'',
          filtDetIndicador?`Indicador: ${filtDetIndicador}`:'',
        ].filter(Boolean).join(' | ') || 'Sin filtros';
        const r2 = await api.post(`/farmacia/productos/pdf-stock-detallado-filtrado`,
          { datos: busqFiltradoDet, descFiltros: filtros },
          { responseType:'blob' });
        const a2 = document.createElement('a');
        a2.href = window.URL.createObjectURL(new Blob([r2.data],{type:'application/pdf'}));
        a2.download = `Stock_Detallado_${Date.now()}.pdf`;
        a2.click(); window.URL.revokeObjectURL(a2.href);
        setModalExportar(false);
        setExportando(false); return;
      } else if (fmt === 'excel-stock') {
        url = `/farmacia/productos/excel-stock?ueId=${ueId}&busqueda=${encodeURIComponent(busqueda)}`;
        filename = `Stock_${Date.now()}.xlsx`;
      } else if (fmt === 'excel-stock-detallado') {
        const filtros = [
          busqDet?`Producto: ${nombreDetSel||busqDet}`:'',
          filtDetIpress?`IPRESS: ${filtDetIpress}`:'',
          filtDetExtra?`Lote/RS/FF: ${filtDetExtra}`:'',
          filtDetEsencial?`Esencial: ${filtDetEsencial}`:'',
          filtDetEstrategico?`Estratégico: ${filtDetEstrategico}`:'',
          filtDetIndicador?`Indicador: ${filtDetIndicador}`:'',
        ].filter(Boolean).join(' | ') || 'Sin filtros';
        const r3 = await api.post(`/farmacia/productos/excel-stock-detallado-filtrado`,
          { datos: busqFiltradoDet, descFiltros: filtros },
          { responseType:'blob' });
        const a3 = document.createElement('a');
        a3.href = window.URL.createObjectURL(new Blob([r3.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        a3.download = `Stock_Detallado_${Date.now()}.xlsx`;
        a3.click(); window.URL.revokeObjectURL(a3.href);
        setModalExportar(false);
        setExportando(false); return;
      } else if (fmt === 'excel-ficha') {
        const periodo = new Date().getFullYear() + String(new Date().getMonth()+1).padStart(2,'0');
        const entidadExport = fichaIpress
          ? { idEntidad: fichaIpress.idEstablecimiento, idUE: ueId, tipoEntidad: 'I' }
          : { idEntidad: ueId, idUE: ueId, tipoEntidad: 'U' };
        const r4 = await api.get(`/farmacia/productos/${mFicha.codigo}/desagregado-fp/excel`, {
          params:{ periodoRef:periodo, ...entidadExport, codigoMed:mFicha.codigo, nombre:mFicha.nombre },
          responseType:'blob'
        });
        const a4 = document.createElement('a');
        a4.href = window.URL.createObjectURL(new Blob([r4.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        a4.download = `Consumo_FP_${mFicha.codigo}_${periodo}.xlsx`;
        a4.click(); window.URL.revokeObjectURL(a4.href);
        setModalExportar(false);
        setExportando(false); return;
      } else if (fmt === 'excel-ficha-detallado') {
        const periodo = new Date().getFullYear() + String(new Date().getMonth()+1).padStart(2,'0');
        const r5 = await api.get(`/farmacia/productos/${mFicha.codigo}/desagregado-fp/excel-detallado`, {
          params:{ periodoRef:periodo, idEntidad:ueId, idUE:ueId, tipoEntidad:'U', codigoMed:mFicha.codigo, nombre:mFicha.nombre },
          responseType:'blob'
        });
        const a5 = document.createElement('a');
        a5.href = window.URL.createObjectURL(new Blob([r5.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        a5.download = `Consumo_FP_Detallado_${mFicha.codigo}_${periodo}.xlsx`;
        a5.click(); window.URL.revokeObjectURL(a5.href);
        setModalExportar(false);
        setExportando(false); return;
      } else if (fmt === 'pdf-vencimiento') {
        url = `/farmacia/productos/pdf-vencimiento?idEstablecimiento=${ueId}&ipress=${encodeURIComponent(fIpress)}&meses=${fMeses}&estado=${encodeURIComponent(fEstado)}`;
        filename = `Vencimiento_${Date.now()}.pdf`;
      } else if (fmt === 'excel-vencimiento') {
        url = `/farmacia/productos/excel-vencimiento?idEstablecimiento=${ueId}&ipress=${encodeURIComponent(fIpress)}&meses=${fMeses}&estado=${encodeURIComponent(fEstado)}`;
        filename = `Vencimiento_${Date.now()}.xlsx`;
      }

      const mime = fmt.startsWith('excel') ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf';
      const r = await api.get(url, { responseType:'blob' });
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(new Blob([r.data],{ type:mime }));
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(a.href);
      setModalExportar(false);
    } catch { setError('export','No pudimos generar el archivo. Inténtalo nuevamente.'); } finally { setExportando(false); }
  };

  const ipressSel    = ipress.find(i => i.idEstablecimiento === fIpress);
  const mostrarIpress = ipressSel?.nombre === 'TODOS' || ipressSel?.nombre === 'FARMACIAS DEL HOSPITAL';

  const INDICADOR_CFG_DET = {
    'SOBRESTOCK':   {bg:'#EDFAF2',border:'#B7EFD0',text:'#1A6B3C',dot:'#65AA91'},
    'NORMOSTOCK':   {bg:'#EDFAF2',border:'#B7EFD0',text:'#1A6B3C',dot:'#7CB287'},
    'SUBSTOCK':     {bg:'#FFF8E6',border:'#FFE9A0',text:'#8B6914',dot:'#D4A365'},
    'DESABASTECIDO':{bg:'#FFF0EF',border:'#FFD4D1',text:'#C0392B',dot:'#D58089'},
    'SIN ROTACION': {bg:'#F2F2F7',border:'#D1D1D6',text:'#636366',dot:'#8E8E93'},
    'SIN CONSUMO':  {bg:'#F2F2F7',border:'#D1D1D6',text:'#636366',dot:'#8E8E93'},
    'NO APLICA':    {bg:'#F0EFFF',border:'#C7C7F0',text:'#3730A3',dot:'#5E5CE6'},
  };
const COLS_OCULTAS_DET = React.useMemo(()=>{
    const base = ['MEDCOD','fechaarchivodbf','TIPO_ESTABLECIMIENTO','Tipsum','ffinan'];
    if(busqDet.length>=2) return [...base,'NOMBRE_MEDICAMENTO'];
    return base;
  },[busqDet]);
  const anchoColDetalle = c => ({NOMBRE_MEDICAMENTO:220,ESTABLECIMIENTO:155,Indicador_DIGEMID:140,ESENCIAL:65,ESTRATEGICO:80,MEDLOTE:85,MEDREGSAN:90,MEDFECHVTO:95,fecharegistro:92,Stkpreo:75,STOCK:70,StockTotal:80,CPMA:70,MSD:65}[c] || 95);
  const COLS_NUM_RIGHT_DET = ['Stkpreo','STOCK','StockTotal','CPMA','MSD'];
  const NOMBRES_DET = {ESTABLECIMIENTO:'IPRESS',NOMBRE_MEDICAMENTO:'Producto',MEDREGSAN:'Reg. San.',MEDLOTE:'Lote',MEDFECHVTO:'F. Venc.',Tipsum:'Tip.Sum',ffinan:'F.Finan',Stkpreo:'Precio',STOCK:'Stock',CPMA:'CPMA',StockTotal:'Stock Total',MSD:'MSD',Indicador_DIGEMID:'Indicador',fecharegistro:'Actualiz.'};
  const fmtValDet = (col,val) => {
    if(val===null||val===undefined) return '-';
    if(typeof val==='number'&&!Number.isInteger(val)) return col.toLowerCase().includes('precio')?val.toFixed(6):val.toFixed(2);
    const s = String(val);
    if(s.match(/^\d{4}-\d{2}-\d{2}T/)){
      const d=new Date(s);
      const dd=String(d.getDate()).padStart(2,'0');
      const mm=String(d.getMonth()+1).padStart(2,'0');
      const yy=d.getFullYear();
      const hh=String(d.getHours()).padStart(2,'0');
      const mi=String(d.getMinutes()).padStart(2,'0');
      return hh==='00'&&mi==='00'?`${dd}/${mm}/${yy}`:`${dd}/${mm}/${yy} ${hh}:${mi}`;
    }
    return s;
  };
  const colsDet = React.useMemo(()=>detData.length>0 ? Object.keys(detData[0]).filter(c=>!COLS_OCULTAS_DET.includes(c)) : [],[detData,COLS_OCULTAS_DET]);
  const busqFiltradoDet = React.useMemo(()=>{
    let f = detData;
    if(busqDet.length>=2) f=f.filter(d=>(d['NOMBRE_MEDICAMENTO']||'').toLowerCase().includes(busqDet.toLowerCase())||String(d['MEDCOD']||'').toLowerCase().includes(busqDet.toLowerCase()));
    if(filtDetIpress) f=f.filter(d=>(d['ESTABLECIMIENTO']||'')===filtDetIpress);
    if(filtDetExtra) { const b=filtDetExtra.toLowerCase(); f=f.filter(d=>(d['MEDLOTE']||'').toLowerCase().includes(b)||(d['MEDREGSAN']||'').toLowerCase().includes(b)||(d['ffinan']||'').toLowerCase().includes(b)); }
    if(filtDetEsencial) f=f.filter(d=>(d['ESENCIAL']||'').toUpperCase()===filtDetEsencial);
    if(filtDetEstrategico) f=f.filter(d=>(d['ESTRATEGICO']||'').toUpperCase()===filtDetEstrategico);
    if(filtDetIndicador) f=f.filter(d=>(d['Indicador_DIGEMID']||'').toUpperCase()===filtDetIndicador);
    return f;
  },[detData,busqDet,filtDetIpress,filtDetExtra,filtDetEsencial,filtDetEstrategico,filtDetIndicador]);
  const ipressUnicas    = React.useMemo(()=>new Set(busqFiltradoDet.map(d=>d['ESTABLECIMIENTO'])).size,[busqFiltradoDet]);
  const valorizadoDet   = React.useMemo(()=>busqFiltradoDet.reduce((s,d)=>s+((Number(d['STOCK']||0))*(Number(d['Stkpreo']||0))),0),[busqFiltradoDet]);
  const productosUnicos = React.useMemo(()=>{
    const vistos = new Set();
    return busqFiltradoDet.filter(d=>{
      const key = `${d['ESTABLECIMIENTO']}|${d['MEDCOD']}`;
      if(vistos.has(key)) return false;
      vistos.add(key); return true;
    });
  },[busqFiltradoDet]);
  const totalDet        = productosUnicos.length;
  const enRiesgoDet     = React.useMemo(()=>productosUnicos.filter(d=>['SUBSTOCK','DESABASTECIDO'].includes((d['Indicador_DIGEMID']||'').toUpperCase())).length,[productosUnicos]);
  const resumenDet      = React.useMemo(()=>Object.keys(INDICADOR_CFG_DET).map(k=>({
    key:k, count:productosUnicos.filter(d=>(d['Indicador_DIGEMID']||'').toUpperCase()===k).length
  })).filter(r=>r.count>0),[productosUnicos]);
  const detPag          = busqFiltradoDet.slice((pgDet-1)*rppDet, pgDet*rppDet);
  const totalPagsDet    = Math.max(1,Math.ceil(busqFiltradoDet.length/rppDet));

  return (
    <Box className="pharmacy-page productos-page" sx={{minHeight:'100vh',bgcolor:IOS.bg}}>
      <ModalExportar
        open={modalExportar}
        onClose={()=>!exportando&&setModalExportar(false)}
        tab={tab}
        totalStock={tab===1?busqFiltradoDet.length:totalReg}
        totalVenc={totalRegV}
        onExportar={handleExportar}
        exportando={exportando}
        fichaIpress={fichaIpress} error={errors.export}
      />

      <HeaderIOS titulo="Productos" subtitulo="Farmacia"
        onHome={()=>navigate('/farmacia')} onLogout={handleLogout}
        nombreCompleto={user?.nombreCompleto||user?.usuario||''}
        avatarLetra={(user?.nombreCompleto||user?.usuario||'U').charAt(0).toUpperCase()}/>

      <Box className="pharmacy-content" sx={{maxWidth:1600,mx:'auto',px:{xs:1.5,sm:3},pt:2.5,pb:5}}>

        {/* Tabs + acciones */}
        <Box className="pharmacy-inline-tabs pharmacy-layout" sx={{display:'flex',alignItems:'center',justifyContent:'space-between',mb:2.5,flexWrap:'wrap',gap:1.5}}>
          <PharmacyTabs value={tab} onChange={i=>{if(i===tab)return;if(i===0||i===2)setLoading(true);if(i<3)setMFicha({open:false,codigo:null,nombre:null});setTab(i);}} options={[...['Stock','Detallado','Vencimiento'], ...(mFicha.open ? ['Ficha'] : [])]}/>

          <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1}}>
            {/* Última actualización — abre el mismo modal en las 3 pestañas */}
            <Box className="pharmacy-layout pharmacy-action" aria-label="Ver actualizaciones" component="button" onClick={()=>setMActs(true)} title={`Última actualización: ${ultimaAct}`}
              sx={{width:38,height:38,minWidth:38,minHeight:38,boxSizing:'border-box',flexShrink:0,
                borderRadius:'50%',border:`1px solid ${IOS.separator}`,
                bgcolor:IOS.surface,cursor:'pointer',display:'flex',alignItems:'center',
                justifyContent:'center',transition:'all 0.2s',
                '&:hover':{bgcolor:IOS.bg,transform:'scale(1.05)'}}}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="2" strokeLinecap="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
            </Box>

            {/* Botón exportar redondo verde */}
            <Box className="pharmacy-layout pharmacy-action" aria-label="Descargar reporte" component="button" onClick={()=>{setError('export',null);setModalExportar(true);}} disabled={exportando||((tab===0||tab===2)&&loading)}
              sx={{width:38,height:38,minWidth:38,minHeight:38,boxSizing:'border-box',flexShrink:0,
                borderRadius:'50%',border:'none',
                bgcolor:IOS.green,cursor:'pointer',display:'flex',alignItems:'center',
                justifyContent:'center',boxShadow:`0 4px 12px ${IOS.green}40`,
                transition:'all 0.2s','&:hover':{transform:'scale(1.08)',filter:'brightness(0.92)'}}}>
              {exportando
                ?<CircularProgress size={16} sx={{color:'white'}}/>
                :<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round">
                  <path d="M12 3v13M7 11l5 5 5-5"/><path d="M4 20h16"/>
                </svg>
              }
            </Box>
          </Box>
        </Box>

        {tab!==3&&<Box className="products-intro"><Box><span className="products-eyebrow">Catálogo · Farmacia</span><Typography component="h1">{['Cada producto, en perspectiva','El detalle detrás del stock','Anticipa los vencimientos'][tab]}</Typography><Typography>{['Consulta existencias por almacén y explora la historia de cada producto.','Lotes, disponibilidad y financiamiento por establecimiento.','Revisa los lotes y prioriza los productos que necesitan atención.'][tab]}</Typography></Box><Box className="products-intro-note"><span>{tab===0?'Productos encontrados':tab===1?'Registros filtrados':'Lotes evaluados'}</span><strong>{(tab===0?totalReg:tab===1?busqFiltradoDet.length:totalRegV).toLocaleString('es-PE')}</strong></Box></Box>}
        {errors.meta&&<Alert severity="error" sx={{mb:2}}>{errors.meta}</Alert>}
        {errors[tab]&&<Alert severity="error" sx={{mb:2}} action={<button className="products-text-button" onClick={()=>tab===0?buscar(busqueda,page,rpp):tab===1?cargarDetalle():cargarVenc()}>Reintentar</button>}>{errors[tab]}</Alert>}
        {tab===3 && mFicha.codigo && (
          <FichaProductoModal codigo={mFicha.codigo} nombre={mFicha.nombre} onClose={volverDeFicha} onIpressChange={setFichaIpress}/>
        )}

        {/* ── STOCK ── */}
        {tab===0&&(
          <>
            <Box className="pharmacy-layout pharmacy-card products-stock-toolbar" sx={{display:'flex',gap:1.5,mb:2,flexDirection:{xs:'column',sm:'row'},alignItems:{sm:'center'}}}>
              <Box sx={{position:'relative',flex:{sm:1},maxWidth:{sm:420}}}>
                <Box sx={{position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',
                  color:IOS.label2,pointerEvents:'none'}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                </Box>
                <input aria-label="Buscar en stock" type="text" value={busqueda} placeholder="Buscar producto (mín. 2 caracteres)..."
                  onChange={e=>{setPage(0);setBusq(e.target.value);}}
                  style={{width:'100%',height:36,paddingLeft:30,paddingRight:12,
                    border:`1px solid ${IOS.separator}`,borderRadius:10,fontSize:'0.82rem',
                    color:IOS.label,backgroundColor:IOS.surface,outline:'none',
                    boxSizing:'border-box',fontFamily:'inherit'}}
                  onFocus={e=>e.target.style.borderColor=IOS.blue}
                  onBlur={e=>e.target.style.borderColor=IOS.separator}/>
              </Box>
              <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1.5,ml:{sm:'auto'},flexWrap:'wrap'}}>
                {loading&&<CircularProgress size={15} sx={{color:IOS.blue}}/>}
                <Box sx={{px:1,py:0.3,bgcolor:IOS.bg,borderRadius:'20px',border:`1px solid ${IOS.separator}`}}>
                  <Typography sx={{fontSize:'0.7rem',fontWeight:600,color:IOS.blue}}>
                    {prods.length.toLocaleString()} / {totalReg.toLocaleString()}
                  </Typography>
                </Box>
                <Typography component="button" className="products-text-button" sx={{fontSize:'0.72rem',color:IOS.blue,cursor:'pointer',
                  '&:hover':{textDecoration:'underline'}}}
                  onClick={()=>setMActs(true)}>
                  Act: {ultimaAct}
                </Typography>
              </Box>
            </Box>

            {/* Desktop */}
            <Box sx={{display:{xs:'none',md:'block'}}}>
              {loading&&prods.length===0
                ?<Box sx={{py:10,textAlign:'center'}}><CircularProgress sx={{color:IOS.blue}}/></Box>
                :<>
                  <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{overflowX:'auto',overflowY:'auto',maxHeight:'calc(100vh - 300px)',
                    borderRadius:'14px',border:`1px solid ${IOS.separator}`,bgcolor:IOS.surface,
                    '&::-webkit-scrollbar':{width:4,height:4},
                    '&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                    <table className="products-stock-table" style={{width:'100%',minWidth:490+(cols.length+2)*116,tableLayout:'fixed',borderCollapse:'separate',borderSpacing:0,fontSize:'0.78rem'}}>
                      <colgroup><col style={{width:90}}/><col/>{cols.map(c=><col key={c.columna} style={{width:116}}/>)}<col style={{width:116}}/><col style={{width:116}}/><col style={{width:110}}/></colgroup>
                      <thead>
                        <tr>
                          <TH>Código</TH>
                          <TH>Producto</TH>
                          {cols.map(c=><TH key={c.columna} right>{c.nombre}</TH>)}
                          <TH right>Periferia</TH>
                          <TH right>Total</TH>
                          <TH>Acciones</TH>
                        </tr>
                      </thead>
                      <tbody>
                        {prods.length===0
                          ?<tr><td colSpan={99} style={{padding:'48px',textAlign:'center',color:IOS.label2,fontSize:'0.85rem'}}>
                            {errors[0]?'No se pudo cargar el stock':busqueda.length===1?'Escribe al menos 2 caracteres':busqueda?'No encontramos productos con esa búsqueda':'Sin productos registrados'}
                          </td></tr>
                          :prods.map((p,i)=>(
                            <TR key={i}>
                              <TD mono>{p.CODIGO}</TD>
                              <TD>{p.PRODUCTO}</TD>
                              {cols.map((c,ci)=>(
                                <TD key={ci} right color={parseFloat(p[c.columna]||0)>0?IOS.label:IOS.label2}>
                                  {parseFloat(p[c.columna]||0).toFixed(0)}
                                </TD>
                              ))}
                              <TD right color={parseFloat(p.PERIFERIA||0)>0?IOS.label:IOS.label2}>
                                {parseFloat(p.PERIFERIA||0).toFixed(0)}
                              </TD>
                              <TD right bold color={IOS.blue}>{(cols.reduce((s,c)=>s+parseFloat(p[c.columna]||0),0)+parseFloat(p.PERIFERIA||0)).toFixed(0)}</TD>
                              <td style={{padding:'6px 10px',textAlign:'center',whiteSpace:'nowrap'}}>
                                <Btn onClick={()=>{setTabAnterior(tab);setFichaIpress(null);setMFicha({open:true,codigo:p.CODIGO,nombre:p.PRODUCTO});setTab(3);}} color={IOS.blue} title="Ver ficha">
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                                </Btn>
                                <Btn onClick={()=>{ setPgDet(1);setBusqDet(String(p.CODIGO)); setNombreDetSel(p.PRODUCTO); setTab(1); }} color="#EC4899" title="Ver detalle IPRESS">
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/></svg>
                                </Btn>
                              </td>
                            </TR>
                          ))
                        }
                      </tbody>
                      {/* Fila totales */}
                      {prods.length>0&&(
                        <tfoot>
                          <tr style={{backgroundColor:IOS.bg,borderTop:`2px solid ${IOS.separator}`}}>
                            <td style={{padding:'9px 12px',fontSize: '0.72rem',fontWeight:700,color:IOS.label2}} colSpan={2}>
                              TOTAL DE ESTA PÁGINA · {prods.length.toLocaleString()} productos
                            </td>
                            {cols.map((c,ci)=>(
                              <td key={ci} style={{padding:'9px 12px',textAlign:'right',fontWeight:700,color:IOS.label,fontSize:'0.75rem'}}>
                                {prods.reduce((s,p)=>s+parseFloat(p[c.columna]||0),0).toFixed(0)}
                              </td>
                            ))}
                            <td style={{padding:'9px 12px',textAlign:'right',fontWeight:700,color:IOS.label,fontSize:'0.75rem'}}>
                              {prods.reduce((s,p)=>s+parseFloat(p.PERIFERIA||0),0).toFixed(0)}
                            </td>
                            <td style={{padding:'9px 12px',textAlign:'right',fontWeight:800,color:IOS.blue,fontSize:'0.82rem'}}>
                              {prods.reduce((s,p)=>s+cols.reduce((t,c)=>t+parseFloat(p[c.columna]||0),0)+parseFloat(p.PERIFERIA||0),0).toFixed(0)}
                            </td>
                            <td/>
                          </tr>
                        </tfoot>
                      )}
                    </table>
                  </Box>
                  <Box sx={{bgcolor:IOS.surface,borderRadius:'12px',mt:0.5}}>
                    <TablePagination component="div" count={totalReg} page={page}
                      onPageChange={(_,p)=>setPage(p)} rowsPerPage={rpp}
                      onRowsPerPageChange={e=>{setRpp(parseInt(e.target.value,10));setPage(0);}}
                      rowsPerPageOptions={[10,25,50,100,200]} labelRowsPerPage="Filas:"
                      labelDisplayedRows={({from,to,count})=>`${from}–${to} de ${count}`}/>
                  </Box>
                </>
              }
            </Box>

            {/* Móvil */}
            <Box sx={{display:{xs:'block',md:'none'}}}>
              {loading&&prods.length===0&&<Box className="products-loading" role="status"><CircularProgress size={26}/><Typography>Consultando productos…</Typography></Box>}
              {prods.length===0&&!loading&&(
                <Box sx={{py:8,textAlign:'center'}}>
                  <Typography sx={{color:IOS.label2,fontSize:'0.85rem'}}>
                    {errors[0]?'No se pudo cargar el stock':busqueda.length===1?'Escribe al menos 2 caracteres':busqueda?'No encontramos productos con esa búsqueda':'Sin productos registrados'}
                  </Typography>
                </Box>
              )}
              {prods.map((p,i)=>(
                <Box className="products-mobile-card" key={i} sx={{bgcolor:IOS.surface,borderRadius:'14px',p:2,mb:1.5,
                  boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>
                  <Box className="pharmacy-layout" sx={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',mb:1.5}}>
                    <Box sx={{flex:1,pr:1}}>
                      <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label,lineHeight:1.3,mb:0.3}}>{p.PRODUCTO}</Typography>
                      <Typography sx={{fontSize: '0.72rem',color:IOS.label2,fontFamily:'monospace'}}>{p.CODIGO}</Typography>
                    </Box>
                    <Box className="pharmacy-layout" sx={{display:'flex',gap:0.5}}>
                      <Btn onClick={()=>{setTabAnterior(tab);setMFicha({open:true,codigo:p.CODIGO,nombre:p.PRODUCTO});setTab(3);}} color={IOS.blue} title="Ficha">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                      </Btn>
                      <Btn onClick={()=>{ setPgDet(1);setBusqDet(String(p.CODIGO)); setTab(1); }} color="#EC4899" title="Detallado">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/></svg>
                      </Btn>
                    </Box>
                  </Box>
                  <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:'repeat(2,minmax(0,1fr))',gap:1}}>
                    {cols.map(c=>{
                      const v=parseFloat(p[c.columna])||0;
                      if(v<=0)return null;
                      return(
                        <Box key={c.columna} sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                          <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>{c.nombre}</Typography>
                          <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label}}>{v.toFixed(0)}</Typography>
                        </Box>
                      );
                    })}
                    {parseFloat(p.PERIFERIA||0)>0&&(
                      <Box sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                        <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>Periferia</Typography>
                        <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label}}>{parseFloat(p.PERIFERIA||0).toFixed(0)}</Typography>
                      </Box>
                    )}
                    <Box sx={{bgcolor:`${IOS.blue}12`,borderRadius:'8px',p:1,gridColumn:'1 / -1'}}>
                      <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.blue,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>Total</Typography>
                      <Typography sx={{fontSize:'1rem',fontWeight:800,color:IOS.blue}}>{(cols.reduce((s,c)=>s+parseFloat(p[c.columna]||0),0)+parseFloat(p.PERIFERIA||0)).toFixed(0)}</Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
              <Box sx={{bgcolor:IOS.surface,borderRadius:'12px',mt:1}}>
                <TablePagination component="div" count={totalReg} page={page}
                  onPageChange={(_,p)=>setPage(p)} rowsPerPage={rpp}
                  onRowsPerPageChange={e=>{setRpp(parseInt(e.target.value,10));setPage(0);}}
                  rowsPerPageOptions={[10,25,50]} labelRowsPerPage=""
                  labelDisplayedRows={({from,to,count})=>`${from}-${to} / ${count}`}/>
              </Box>
            </Box>
          </>
        )}

        {/* ── DETALLE IPRESS ── */}
        {tab===1&&(
          <Box>
            {/* Filtros */}
            <Box className="pharmacy-layout pharmacy-card products-detail-filters" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2,mb:2.5,
              boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,
              display:'grid',gridTemplateColumns:{xs:'1fr',sm:'1fr 1fr',md:'2fr 1.5fr 1.5fr auto auto auto auto'},
              gap:1.5,alignItems:'end'}}>
              <Autocomplete freeSolo options={[...new Map(detData.map(d=>[String(d.MEDCOD),d])).values()]} inputValue={nombreDetSel||busqDet} value={null}
                getOptionLabel={option=>typeof option==='string'?option:option.NOMBRE_MEDICAMENTO||String(option.MEDCOD)}
                filterOptions={(options,{inputValue})=>options.filter(d=>(String(d.MEDCOD)+' '+d.NOMBRE_MEDICAMENTO).toLowerCase().includes(inputValue.toLowerCase())).slice(0,8)}
                onInputChange={(_,value,reason)=>{if(reason==='input'||reason==='clear'){setBusqDet(value);setNombreDetSel('');setPgDet(1);}}}
                onChange={(_,value)=>{setBusqDet(typeof value==='string'?value:String(value?.MEDCOD||''));setNombreDetSel(typeof value==='object'?value?.NOMBRE_MEDICAMENTO||'':'');setPgDet(1);}}
                renderOption={(props,option)=><li {...props} key={option.MEDCOD}><Box><Typography sx={{fontSize:13,fontWeight:600}}>{option.NOMBRE_MEDICAMENTO}</Typography><Typography sx={{fontSize:11,color:'#8591A3'}}>{option.MEDCOD}</Typography></Box></li>}
                renderInput={params=><TextField {...params} label="Producto o código" placeholder="Busca un producto…" size="small"/>}/>
              {/* Filtro IPRESS desde datos cargados */}
              <Box className="pharmacy-layout" sx={{display:'flex',flexDirection:'column',gap:0.3}}>
                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase'}}>IPRESS</Typography>
                <Sel aria-label="Filtrar detalle por IPRESS" value={filtDetIpress} onChange={e=>{setFiltDetIpress(e.target.value);setPgDet(1);}} w="100%">
                  <option value="">Todas</option>
                  {[...new Set(detData.map(d=>d['ESTABLECIMIENTO']).filter(Boolean))].sort().map((ip,i)=>(
                    <option key={i} value={ip}>{ip}</option>
                  ))}
                </Sel>
              </Box>
              {/* Filtro por lote/reg.san/ffinan */}
              <Box className="pharmacy-layout" sx={{display:'flex',flexDirection:'column',gap:0.3}}>
                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase'}}>Lote / Reg.San / F.Finan</Typography>
                <input aria-label="Lote, registro sanitario o financiamiento" type="text" value={filtDetExtra} placeholder="Buscar lote, reg. san., financ..."
                  onChange={e=>{setFiltDetExtra(e.target.value);setPgDet(1);}}
                  style={{height:34,padding:'0 10px',border:`1px solid ${IOS.separator}`,borderRadius:8,fontSize:'0.8rem',color:IOS.label,backgroundColor:IOS.surface,outline:'none',boxSizing:'border-box',fontFamily:'inherit',width:'100%'}}
                  onFocus={e=>e.target.style.borderColor=IOS.blue}
                  onBlur={e=>e.target.style.borderColor=IOS.separator}/>
              </Box>
              <Sel label="Esencial" value={filtDetEsencial} onChange={e=>{setFiltDetEsencial(e.target.value);setPgDet(1);}} w="100%">
                <option value="">Todos</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </Sel>
              <Sel label="Estratégico" value={filtDetEstrategico} onChange={e=>{setFiltDetEstrategico(e.target.value);setPgDet(1);}} w="100%">
                <option value="">Todos</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </Sel>
              <Sel label="Indicador" value={filtDetIndicador} onChange={e=>{setFiltDetIndicador(e.target.value);setPgDet(1);}} w="100%">
                <option value="">Todos</option>
                {Object.keys(INDICADOR_CFG_DET).map(k=><option key={k} value={k}>{k}</option>)}
              </Sel>
              <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1,gridColumn:{xs:'1 / -1',md:'auto'}}}>
                {loadDet&&<CircularProgress size={15} sx={{color:IOS.blue}}/>}
                {detCargadoEn&&!loadDet&&(()=>{
                  const mins=Math.floor((new Date()-detCargadoEn)/60000);
                  const vencida=mins>=60;
                  return(
                    <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:0.8,px:1.2,py:0.6,
                      bgcolor:vencida?`${IOS.orange}12`:IOS.bg,
                      borderRadius:'20px',border:`1px solid ${vencida?IOS.orange:IOS.separator}`,
                      cursor:'pointer',transition:'all 0.15s','&:hover':{filter:'brightness(0.95)'}}}
                      onClick={cargarDetalle}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke={vencida?IOS.orange:IOS.label2} strokeWidth="2" strokeLinecap="round">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-.08-4.27"/>
                      </svg>
                      <Typography sx={{fontSize:'0.7rem',fontWeight:600,
                        color:vencida?IOS.orange:IOS.label2}}>
                        {vencida?'Actualizar':'Act. hace '+mins+'m'}
                      </Typography>
                    </Box>
                  );
                })()}
                <Box sx={{px:1.2,py:0.6,bgcolor:IOS.bg,borderRadius:'20px',border:`1px solid ${IOS.separator}`}}>
                  <Typography sx={{fontSize:'0.7rem',fontWeight:600,color:IOS.label2}}>{busqFiltradoDet.length.toLocaleString()} registros</Typography>
                </Box>
              </Box>
            </Box>

            {!loadDet&&!detData.length&&!errors[1]&&<Box className="pharmacy-card products-empty">No hay registros de detalle disponibles.</Box>}
            {loadDet&&detData.length===0
              ?<Box sx={{py:12,textAlign:'center'}}><CircularProgress sx={{color:IOS.blue}}/></Box>
              :detData.length>0&&(
                <Box>
                  {/* KPIs */}
                  <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:{xs:'1fr 1fr',sm:'repeat(auto-fit,minmax(180px,1fr))',xl:`repeat(${Math.min(resumenDet.length+1,7)},minmax(0,1fr))`},gap:1.5,mb:2.5}}>
                    <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2,boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>
                      <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:1}}>
                        <Box>
                          <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.07em',textTransform:'uppercase',mb:0.8}}>IPRESS</Typography>
                          <Typography sx={{fontSize:'1.6rem',fontWeight:800,color:IOS.blue,lineHeight:1,letterSpacing:'-0.03em',mb:0.4}}>{ipressUnicas.toLocaleString()}</Typography>
                          <Typography sx={{fontSize: '0.72rem',color:IOS.red,fontWeight:600,mb:0.2}}>{enRiesgoDet} en riesgo</Typography>
                          <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>S/ {valorizadoDet.toLocaleString('es-PE',{minimumFractionDigits:2,maximumFractionDigits:2})}</Typography>
                        </Box>
                        <Box sx={{width:42,height:42,borderRadius:'12px',bgcolor:`${IOS.blue}12`,display:{xs:'none',sm:'flex'},alignItems:'center',justifyContent:'center',flexShrink:0}}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
                        </Box>
                      </Box>
                    </Box>
                    {resumenDet.map(({key,count})=>{
                      const cfg=INDICADOR_CFG_DET[key];
                      const pct=totalDet>0?Math.round((count/totalDet)*100):0;
                      return (
                        <PharmacyMetric key={key} label={key} value={count.toLocaleString()} color={cfg.dot} progress={pct} sub={<>{pct}% · S/ {busqFiltradoDet.filter(d=>(d['Indicador_DIGEMID']||'').toUpperCase()===key).reduce((s,d)=>s+(Number(d['STOCK']||0)*Number(d['Stkpreo']||0)),0).toLocaleString('es-PE',{minimumFractionDigits:2,maximumFractionDigits:2})}</>} />
                      );
                    })}
                  </Box>

                  

                  {!busqFiltradoDet.length&&<Box className="pharmacy-card products-empty">No hay registros que coincidan con los filtros.</Box>}
                  {/* Móvil — cards */}
                  <Box sx={{display:{xs:'block',md:'none'},mb:2}}>
                    {detPag.map((det,ri)=>{
                      const ind=det['Indicador_DIGEMID']||'';
                      const cfg=INDICADOR_CFG_DET[ind?.toUpperCase()]||{bg:'transparent',text:IOS.label,dot:'#8E8E93',border:IOS.separator};
                      return(
                        <Box className="products-mobile-card" key={ri} sx={{bgcolor:IOS.surface,borderRadius:'14px',mb:1.5,
                          boxShadow:'0 1px 4px rgba(0,0,0,0.07)',
                          borderLeft:`3px solid ${cfg.dot}`,overflow:'hidden'}}>
                          {/* Cabecera */}
                          <Box className="pharmacy-layout" sx={{px:2,py:1.2,bgcolor:cfg.bg||IOS.bg,borderBottom:`1px solid ${IOS.separator}`,
                            display:'flex',alignItems:'center',justifyContent:'space-between',gap:1}}>
                            <Box sx={{minWidth:0}}>
                              <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:IOS.label,
                                overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                                {det['NOMBRE_MEDICAMENTO']||det['ESTABLECIMIENTO']}
                              </Typography>
                              {det['NOMBRE_MEDICAMENTO']&&(
                                <Typography sx={{fontSize: '0.72rem',color:IOS.label2,mt:0.2,
                                  overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                                  {det['ESTABLECIMIENTO']}
                                </Typography>
                              )}
                            </Box>
                            <Box sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:0.8,py:0.25,
                              borderRadius:'20px',bgcolor:cfg.bg,border:`1px solid ${cfg.border}`,flexShrink:0}}>
                              <Box sx={{width:5,height:5,borderRadius:'50%',bgcolor:cfg.dot}}/>
                              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:cfg.text}}>{ind||'N/A'}</Typography>
                            </Box>
                          </Box>
                          {/* Body */}
                          <Box sx={{px:2,py:1.2}}>
                            <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:1,mb:1}}>
                              <Box sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>Código</Typography>
                                <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:IOS.label,fontFamily:'monospace'}}>{det['MEDCOD']||'-'}</Typography>
                              </Box>
                              <Box sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>Lote</Typography>
                                <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:IOS.label,fontFamily:'monospace'}}>{det['MEDLOTE']||'-'}</Typography>
                              </Box>
                              <Box sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>F. Venc.</Typography>
                                <Typography sx={{fontSize:'0.78rem',fontWeight:700,color:IOS.label}}>{fmtValDet('MEDFECHVTO',det['MEDFECHVTO'])}</Typography>
                              </Box>
                              <Box sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>Esencial</Typography>
                                <Box sx={{display:'inline-flex',alignItems:'center',gap:0.4,px:0.7,py:0.2,borderRadius:'20px',
                                  bgcolor:det['ESENCIAL']==='SI'?'#EDFAF2':'#FFF8E6',
                                  border:`1px solid ${det['ESENCIAL']==='SI'?'#B7EFD0':'#FFE9A0'}`}}>
                                  <Box sx={{width:4,height:4,borderRadius:'50%',bgcolor:det['ESENCIAL']==='SI'?'#65AA91':'#D4A365'}}/>
                                  <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:det['ESENCIAL']==='SI'?'#1A6B3C':'#8B6914'}}>{det['ESENCIAL']||'NO'}</Typography>
                                </Box>
                              </Box>
                            </Box>
                            <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:1}}>
                              <Box sx={{bgcolor:`${cfg.dot}12`,borderRadius:'8px',p:1}}>
                                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>Stock</Typography>
                                <Typography sx={{fontSize:'0.9rem',fontWeight:800,color:cfg.text||IOS.label}}>{Number(det['STOCK']||0).toLocaleString()}</Typography>
                              </Box>
                              <Box sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>CPMA</Typography>
                                <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label}}>{Number(det['CPMA']||0).toFixed(2)}</Typography>
                              </Box>
                              <Box sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>MSD</Typography>
                                <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label}}>{Number(det['MSD']||0).toFixed(2)}</Typography>
                              </Box>
                            </Box>
                            <Box className="pharmacy-layout" sx={{display:'flex',justifyContent:'space-between',alignItems:'center',mt:1,pt:1,borderTop:`1px solid ${IOS.separator}`}}>
                              <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>{det['MEDREGSAN']}</Typography>
                              <Typography sx={{fontSize: '0.72rem',color:IOS.label2}}>S/ {Number(det['Stkpreo']||0).toFixed(4)}</Typography>
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                    {/* Paginación móvil */}
                    <Box className="pharmacy-layout" sx={{bgcolor:IOS.surface,borderRadius:'12px',mt:1,display:'flex',alignItems:'center',justifyContent:'space-between',px:2,py:1.2}}>
                      <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>{busqFiltradoDet.length?((pgDet-1)*rppDet)+1:0}–{Math.min(pgDet*rppDet,busqFiltradoDet.length)} / {busqFiltradoDet.length}</Typography>
                      <Box className="pharmacy-layout" sx={{display:'flex',gap:0.5}}>
                        {[['‹',()=>setPgDet(p=>Math.max(1,p-1)),pgDet===1],['›',()=>setPgDet(p=>Math.min(totalPagsDet,p+1)),pgDet===totalPagsDet]].map(([lbl,fn,dis],i)=>(
                          <Box className="pharmacy-layout pharmacy-action" key={i} component="button" aria-label={{'«':'Primera página','‹':'Página anterior','›':'Página siguiente','»':'Última página'}[lbl]} onClick={fn} disabled={dis}
                            sx={{width:32,height:32,borderRadius:'8px',border:`1px solid ${IOS.separator}`,bgcolor:IOS.surface,cursor:dis?'default':'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1rem',color:IOS.label,opacity:dis?0.3:1}}>{lbl}</Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>

                  {/* Tabla desktop */}
                  <Box sx={{display:{xs:'none',md:'block'}}}>
                  <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`,overflow:'hidden'}}>
                    <Box className="pharmacy-layout" sx={{px:2,py:1.2,borderBottom:`1px solid ${IOS.separator}`,display:'flex',alignItems:'center',justifyContent:'flex-end'}}>
                      <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>{busqFiltradoDet.length.toLocaleString()} registros</Typography>
                    </Box>
                    <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{overflowX:'auto',overflowY:'auto',maxHeight:'calc(100vh - 440px)',
                      '&::-webkit-scrollbar':{width:4,height:4},'&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                      <table className="products-detail-table" style={{width:'100%',minWidth:colsDet.reduce((total,c)=>total+anchoColDetalle(c),0),borderCollapse:'collapse',tableLayout:'fixed',fontSize:'0.72rem'}}>
                        <colgroup>
                          {colsDet.map((c,i)=>(
                            <col key={i} style={{width:anchoColDetalle(c)}}/>
                          ))}
                        </colgroup>
                        <thead><tr>
                          {colsDet.map((c,i)=>(
                            <th key={i} title={c==='fecharegistro'?'Actualización':NOMBRES_DET[c]||c} style={{padding:'9px 10px',textAlign:COLS_NUM_RIGHT_DET.includes(c)?'right':'left',fontSize: '0.72rem',fontWeight:700,color:IOS.label2,letterSpacing:'0.06em',textTransform:'uppercase',backgroundColor:IOS.surface,borderBottom:`1px solid ${IOS.separator}`,position:'sticky',top:0,whiteSpace:'nowrap',zIndex:1,overflow:'hidden',textOverflow:'ellipsis'}}>
                              {NOMBRES_DET[c]||c}
                            </th>
                          ))}
                          </tr></thead>
                        <tbody>
                          {detPag.length===0
                            ?<tr><td colSpan={99} style={{padding:'40px',textAlign:'center',color:IOS.label2}}>Sin registros</td></tr>
                            :detPag.map((det,ri)=>{
                              const ind=det['Indicador_DIGEMID']||'';
                              const cfg=INDICADOR_CFG_DET[ind?.toUpperCase()]||{bg:'transparent',text:IOS.label,dot:IOS.label3,border:IOS.separator};
                              return (
                                <tr key={ri} style={{borderBottom:`1px solid ${IOS.separator}`,transition:'background 0.1s'}}
                                  onMouseEnter={e=>e.currentTarget.style.backgroundColor=IOS.bg}
                                  onMouseLeave={e=>e.currentTarget.style.backgroundColor='transparent'}>
                                  {colsDet.map((c,ci)=>{
                                    const val=det[c];
                                    const esInd=c==='Indicador_DIGEMID';
                                    const esColor=COLS_NUM_RIGHT_DET.includes(c)&&!c.includes('Stkpreo');
                                    return (
                                      <td key={ci} style={{padding:'8px 10px',textAlign:COLS_NUM_RIGHT_DET.includes(c)?'right':'left',
                                        backgroundColor:esColor?`${cfg.dot}12`:'transparent',
                                        color:esColor?cfg.text:IOS.label,fontWeight:esColor?600:400,
                                        overflow:'hidden',textOverflow:'ellipsis',
                                        whiteSpace:COLS_NUM_RIGHT_DET.includes(c)||esInd||['MEDLOTE','MEDREGSAN','MEDFECHVTO','Tipsum','ffinan'].includes(c)?'nowrap':'normal',
                                        lineHeight:1.35}}>
                                        {esInd
                                          ?<Box sx={{display:'inline-flex',alignItems:'center',gap:0.5,px:0.8,py:0.25,borderRadius:'20px',bgcolor:cfg.bg,border:`1px solid ${cfg.border}`}}>
                                              <Box sx={{width:5,height:5,borderRadius:'50%',bgcolor:cfg.dot,flexShrink:0}}/>
                                              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:cfg.text,whiteSpace:'nowrap'}}>{val||'N/A'}</Typography>
                                            </Box>
                                          :(c==='ESENCIAL'||c==='ESTRATEGICO')
                                            ?<Box sx={{display:'inline-flex',alignItems:'center',gap:0.4,px:0.7,py:0.2,borderRadius:'20px',
                                                bgcolor:val==='SI'?'#EDFAF2':'#FFF8E6',
                                                border:`1px solid ${val==='SI'?'#B7EFD0':'#FFE9A0'}`}}>
                                                <Box sx={{width:4,height:4,borderRadius:'50%',bgcolor:val==='SI'?'#65AA91':'#D4A365',flexShrink:0}}/>
                                                <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:val==='SI'?'#1A6B3C':'#8B6914'}}>{val||'NO'}</Typography>
                                              </Box>
                                            :c==='fecharegistro'&&val&&!Number.isNaN(new Date(val).getTime())
                                              ?<span className="products-update-date" title={new Date(val).toLocaleString('es-PE')}><span>{new Date(val).toLocaleDateString('es-PE',{day:'2-digit',month:'2-digit',year:'2-digit'})}</span><small>{new Date(val).toLocaleTimeString('es-PE',{hour:'2-digit',minute:'2-digit',hour12:false})}</small></span>
                                              :fmtValDet(c,val)
                                        }
                                      </td>
                                    );
                                  })}
                                  
                                </tr>
                              );
                            })
                          }
                        </tbody>
                      </table>
                    </Box>
                    <Box className="pharmacy-layout" sx={{px:2,py:1.2,borderTop:`1px solid ${IOS.separator}`,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:1}}>
                      <Box className="pharmacy-layout" sx={{display:'flex',alignItems:'center',gap:1.5}}>
                        <Typography sx={{fontSize:'0.72rem',color:IOS.label2}}>{busqFiltradoDet.length?((pgDet-1)*rppDet)+1:0}–{Math.min(pgDet*rppDet,busqFiltradoDet.length)} de {busqFiltradoDet.length.toLocaleString()}</Typography>
                        <PharmacySelect value={rppDet} onChange={e=>{setRppDet(Number(e.target.value));setPgDet(1);}} w={100} aria-label="Filas por página">
                          {[10,25,50,100,200].map(n=><option key={n} value={n}>{n}/pág</option>)}
                        </PharmacySelect>
                      </Box>
                      <Box className="pharmacy-layout" sx={{display:'flex',gap:0.5}}>
                        {[['«',()=>setPgDet(1),pgDet===1],['‹',()=>setPgDet(p=>Math.max(1,p-1)),pgDet===1],['›',()=>setPgDet(p=>Math.min(totalPagsDet,p+1)),pgDet===totalPagsDet],['»',()=>setPgDet(totalPagsDet),pgDet===totalPagsDet]].map(([lbl,fn,dis],i)=>(
                          <Box className="pharmacy-layout pharmacy-action" key={i} component="button" aria-label={{'«':'Primera página','‹':'Página anterior','›':'Página siguiente','»':'Última página'}[lbl]} onClick={fn} disabled={dis}
                            sx={{width:28,height:28,borderRadius:'8px',border:`1px solid ${IOS.separator}`,bgcolor:IOS.surface,cursor:dis?'default':'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.8rem',color:IOS.label,opacity:dis?0.3:1,transition:'all 0.15s','&:hover':{bgcolor:dis?IOS.surface:IOS.bg}}}>{lbl}</Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                  </Box>
                </Box>
              )
            }
          </Box>
        )}

        {/* ── VENCIMIENTO ── */}
        {tab===2&&(
          <>
            <Box className="pharmacy-card" sx={{bgcolor:IOS.surface,borderRadius:'16px',p:2,mb:2,
              boxShadow:'0 1px 4px rgba(0,0,0,0.07)',border:`1px solid ${IOS.separator}`}}>
              <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:{xs:'1fr 1fr',sm:'1fr 1fr 1fr'},gap:1.5,mb:2}}>
                <Sel label="IPRESS" value={fIpress} onChange={e=>{setPageV(0);setFIpress(e.target.value);}} disabled={loading} w="100%">
                  {ipress.map((ip,i)=><option key={i} value={ip.idEstablecimiento}>{ip.nombre}</option>)}
                </Sel>
                <Sel label="EVALUACIÓN" value={fMeses} onChange={e=>{setPageV(0);setFMeses(Number(e.target.value));}} disabled={loading} w="100%">
                  {[1,2,3,4,5,6,12].map(m=><option key={m} value={m}>{m} {m===1?'mes':'meses'}</option>)}
                </Sel>
                <Sel label="ESTADO" value={fEstado} onChange={e=>{setPageV(0);setFEstado(e.target.value);}} disabled={loading} w="100%">
                  <option value="TODOS">Todos</option>
                  <option value="VENCIDO">Vencido</option>
                  <option value="POR VENCER">Por vencer</option>
                  <option value="VIGENTE">Vigente</option>
                </Sel>
              </Box>

              {loading ? <Box className="products-loading" role="status"><CircularProgress size={24}/><Typography>Evaluando vencimientos…</Typography></Box> : !errors[2] && <Box className="products-expiry-metrics">
                {[['Evaluados',totV.totalEvaluados,'#779AC5'],['Vencidos',totV.vencidos,'#D58089'],['Por vencer',totV.porVencer,'#D4A365'],['Vigentes',totV.vigentes,'#65AA91']].map(([label,value,color])=><PharmacyMetric key={label} label={label} value={value.toLocaleString()} color={color} progress={totV.totalEvaluados?value/totV.totalEvaluados*100:0}/>)}
              </Box>}
            </Box>

            {loading
              ?<Box sx={{py:10,textAlign:'center'}}><CircularProgress sx={{color:IOS.blue}}/></Box>
              :<>
                {/* Desktop */}
                <Box sx={{display:{xs:'none',md:'block'}}}>
                  <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{overflowX:'auto',overflowY:'auto',maxHeight:'calc(100vh - 320px)',
                    borderRadius:'14px',border:`1px solid ${IOS.separator}`,bgcolor:IOS.surface,
                    '&::-webkit-scrollbar':{width:4,height:4},
                    '&::-webkit-scrollbar-thumb':{bgcolor:IOS.separator,borderRadius:4}}}>
                    <table className="products-expiry-table" style={{width:'100%',minWidth:1150,borderCollapse:'collapse',fontSize:'0.78rem'}}>
                      <thead>
                        <tr>
                          {mostrarIpress&&<TH>IPRESS</TH>}
                          <TH>Código</TH><TH>Producto</TH>
                          <TH>Reg. San.</TH><TH>Lote</TH><TH>Vencimiento</TH>
                          <TH right>Stock</TH><TH right>Precio</TH>
                          <TH>T. Sum</TH><TH>F. Finan</TH>
                          <TH>Estado</TH><TH right>Días</TH>
                        </tr>
                      </thead>
                      <tbody>
                        {vencP.length===0
                          ?<tr><td colSpan={99} style={{padding:'48px',textAlign:'center',color:IOS.label2}}>Sin productos</td></tr>
                          :vencP.map((p,i)=>{
                            const est=p.EstadoVencimiento||'';
                            const dc=est==='VENCIDO'?IOS.red:est==='POR VENCER'?IOS.orange:IOS.green;
                            return(
                              <TR key={i}>
                                {mostrarIpress&&<TD>{p.Establecimiento}</TD>}
                                <TD mono>{p.Medcod}</TD>
                                <TD>{p.PRODUCTO}</TD>
                                <TD mono>{p.Medregsan}</TD>
                                <TD mono>{p.Medlote}</TD>
                                <TD nowrap>{fmtFecha(p.Medfechvto)}</TD>
                                <TD right>{parseFloat(p.Stksaldode||0).toFixed(2)}</TD>
                                <TD right>{parseFloat(p.Stkprecio||0).toFixed(2)}</TD>
                                <TD>{p.Tipsum}</TD>
                                <TD>{p.Ffinan}</TD>
                                <td style={{padding:'8px 12px'}}><EstadoPill estado={est}/></td>
                                <TD right bold color={dc}>{p.DiasRestantes}</TD>
                              </TR>
                            );
                          })
                        }
                      </tbody>
                    </table>
                  </Box>
                  <Box sx={{bgcolor:IOS.surface,borderRadius:'12px',mt:0.5}}>
                    <TablePagination component="div" count={totalRegV} page={pageV}
                      onPageChange={(_,p)=>setPageV(p)} rowsPerPage={rppV}
                      onRowsPerPageChange={e=>{setRppV(parseInt(e.target.value,10));setPageV(0);}}
                      rowsPerPageOptions={[10,25,50,100,200]} labelRowsPerPage="Filas:"
                      labelDisplayedRows={({from,to,count})=>`${from}–${to} de ${count}`}/>
                  </Box>
                </Box>

                {/* Móvil */}
                <Box sx={{display:{xs:'block',md:'none'}}}>
                  {!vencP.length&&!errors[2]&&<Box className="products-empty">No hay lotes para los filtros seleccionados.</Box>}
                  {vencP.map((p,i)=>{
                    const est=p.EstadoVencimiento;
                    const bc=est==='VENCIDO'?'#D58089':est==='POR VENCER'?'#D4A365':'#65AA91';
                    return(
                      <Box className="products-mobile-card" key={i} sx={{bgcolor:IOS.surface,borderRadius:'14px',p:2,mb:1.5,
                        boxShadow:'0 1px 4px rgba(0,0,0,0.07)',borderLeft:`3px solid ${bc}`}}>
                          {mostrarIpress && (
                          <Typography sx={{fontSize: '0.72rem',fontWeight:600,color:IOS.label2,mb:0.3}}>{p.Establecimiento}</Typography>
                        )}
                        <Typography sx={{fontSize:'0.82rem',fontWeight:700,color:IOS.label,mb:1}}>{p.PRODUCTO}</Typography>
                        <Box className="pharmacy-layout" sx={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:1}}>
                          {[['Código',p.Medcod],['Lote',p.Medlote],
                            ['Stock',parseFloat(p.Stksaldode||0).toFixed(2)],
                            ['Precio',`S/ ${parseFloat(p.Stkprecio||0).toFixed(2)}`]
                          ].map(([l,v])=>(
                            <Box key={l} sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1}}>
                              <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.2}}>{l}</Typography>
                              <Typography sx={{fontSize:'0.8rem',fontWeight:700,color:IOS.label}}>{v}</Typography>
                            </Box>
                          ))}
                          <Box sx={{bgcolor:IOS.bg,borderRadius:'8px',p:1,gridColumn:'1 / -1'}}>
                            <Typography sx={{fontSize: '0.72rem',fontWeight:700,color:IOS.label2,textTransform:'uppercase',letterSpacing:'0.05em',mb:0.4}}>Vencimiento</Typography>
                            <Box className="pharmacy-layout" sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                              <Typography sx={{fontSize:'0.8rem',fontWeight:600}}>{fmtFecha(p.Medfechvto)}</Typography>
                              <EstadoPill estado={est}/>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    );
                  })}
                  <Box sx={{bgcolor:IOS.surface,borderRadius:'12px',mt:1}}>
                    <TablePagination component="div" count={totalRegV} page={pageV}
                      onPageChange={(_,p)=>setPageV(p)} rowsPerPage={rppV}
                      onRowsPerPageChange={e=>{setRppV(parseInt(e.target.value,10));setPageV(0);}}
                      rowsPerPageOptions={[10,25,50]} labelRowsPerPage=""
                      labelDisplayedRows={({from,to,count})=>`${from}-${to} / ${count}`}/>
                  </Box>
                </Box>
              </>
            }
          </>
        )}
      </Box>

      <ActualizacionesModal open={mActs} onClose={()=>setMActs(false)}/>
    </Box>
  );
};

export default Productos;
